import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {betterAuthErrorSchema} from './better-auth-response.schemas';

const signOutResponseSchema = z.object({
  data: z.unknown().nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthSignOutResponse = z.output<typeof signOutResponseSchema>;

export class BetterAuthSignOutResponseValidator implements Validator<BetterAuthSignOutResponse> {
  readonly standardSchema = signOutResponseSchema;

  validate(value: unknown): Result<BetterAuthSignOutResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Unexpected sign-out response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
